import React, {useEffect, useState} from "react";
import s from './SwitchToPitchDetectionPrompt.module.scss';
import {GenericModal} from "../../common/genericModal/GenericModal";
import Checkbox from "../../common/tools/Checkbox/Checkbox";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";
import {useAppSelector} from "../../../redux/hooks";
import Button from "../../common/Button";

export default function SwitchToPitchDetectionPrompt() {
  const canShowSwitchToPitchDetectionPrompt = useAppSelector(lessonPlayerStore.getCanShowSwitchToPitchDetectionPrompt);
  const isPromptAllowedByUser = useAppSelector(lessonPlayerStore.getSwitchToPitchDetectionPromptIsAllowedByUser);
  const isDemoModeOn = lessonPlayerStore.getIsDemoLeftHandSoundEnabled() || lessonPlayerStore.getIsDemoRightHandSoundEnabled();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(isPromptAllowedByUser && isDemoModeOn && canShowSwitchToPitchDetectionPrompt);
  }, [isPromptAllowedByUser, isDemoModeOn, canShowSwitchToPitchDetectionPrompt]);

  if (!isOpen) {
    return null;
  }

  let localIsPromptAllowedByUser: boolean = isPromptAllowedByUser;

  return (
    <GenericModal
      canShow={(): boolean => {
        return isOpen;
      }}
      backgroundColor={"white"}
      title="Switch to mic feedback?"
      onClose={() => {
        lessonPlayerStore.setCanShowSwitchToPitchDetectionPrompt(false);
        lessonPlayerStore.setSwitchToPitchDetectionPromptIsAllowedByUser(localIsPromptAllowedByUser);
      }}
    >
      <div className={s.container}>
        <div className={s.topText}>
          <p>Your keyboard is disconnected, but piano sound demos are still on &mdash; this disables mic feedback and scoring.</p>
          <div className={s.buttonSection}>
            <Button
              text={'Turn On Mic Feedback'}
              onClick={() => {
                lessonPlayerStore.setIsLoopEnabled(false);
                lessonPlayerStore.setIsDemoLeftHandSoundEnabled(false);
                lessonPlayerStore.setIsDemoRightHandSoundEnabled(false);
                lessonPlayerStore.setIsInstantFeedbackEnabled(true);
                lessonPlayerStore.setCanShowSwitchToPitchDetectionPrompt(false);
              }}>
            </Button>
          </div>
          <p><small><strong>Turning on mic feedback disables piano demo sounds.</strong></small></p>
        </div>

        <div className={s.checkBoxSection}>
          <Checkbox
            name={`enableSoundDemoActivatedCheckbox`}
            isChecked={!localIsPromptAllowedByUser}
            label={`Don't show this again`}
            onChange={(isChecked: boolean) => {
              localIsPromptAllowedByUser = !isChecked;
            }}
          />
        </div>
      </div>
    </GenericModal>
  );
}